import React, { useContext } from "react";
import "./styles/filemanager.css";
import { desktopContext } from "./context/desktopContext";

const FileManager = () => {

  const cntxt = useContext(desktopContext)



  const data = [
    // [Project Name, description, id],
    ["Codex", "Cross Platform Notetaking App", "codex"],
    ["Rapid Checkout", "E-Commerce Fullstack WebApp With Auth", "rcheckout"],
    ["Home Gaurd", "Machine Learning Algorithm", "homegaurd"],
    ["Korner", "Linux Hotcorners Like Utility", "korner"],
  ];

  const clickHandler = (file, unqname) =>{
    if(window.innerWidth>600){
      cntxt.setOpenWindowTitle(`Projects/${file}`);
    }

    cntxt.setApp(unqname)
  }

  return (
    <>
      <div className="file-list">
        <div className="file-column">
          <div className="heading">File</div>
          <div className="heading">Description</div>
        </div>

        {data.map((item, index) => {
          return (
            <div key= {index} onClick = {()=>clickHandler(item[0], item[2])} className={`file-column  ${index % 2 === 0 ? "light" : ""}`}>
              <div className="content">{item[0]}</div>
              <div className="content">{item[1]}</div>
            </div>
          );
        })}
      </div>
    </>
  );
};

export default FileManager;
